import Select, { IProps as ISelectProps } from './Select';

export type { ISelectProps };
export default Select;
